
import SEO from '../../components/common/seo/SEO'
import CourseLandingPage from '../../components/Courses/CourseLandingPage/CourseLandingPage'
import solidworksApiCourse from '../../data/cad_section/SolidWorksApiCourse'

function SolidWorkAPIPage() {
    return (
<>

         <SEO
        title="SolidWorks API Customization & Automation Training | SolidWorks API Course | FeesWorth"

        description="Learn SolidWorks API customization and automation using C# and .NET. Master SolidWorks API, CAD automation, macro development, part and assembly automation, drawing automation, and practical projects with expert training at FeesWorth."

        keywords="SolidWorks API Training, SolidWorks API Course, SolidWorks Customization Training, SolidWorks Automation Training, SolidWorks C# Training, SolidWorks .NET API, SolidWorks API Programming, SolidWorks Automation Course, SolidWorks Customization Course, SolidWorks Macro Training"

        canonical="https://feesworth.com/solidworks-api-customization-automation-training"
      />
        <CourseLandingPage course={solidworksApiCourse} />
</>

    )
}

export default SolidWorkAPIPage